import { Icon } from '@sunwebgroup/uds-ui/icon'
import { RichText } from '@sunwebgroup/uds-ui/rich-text'
import { Sheet } from '@sunwebgroup/uds-ui/sheet'
import { Typography } from '@sunwebgroup/uds-ui/typography'
import * as React from 'react'
import { useCMSPageField } from '@/cms/fields'
import { useIntl } from '@/intl'
import { useOptimizelyFlagContext } from '@/scopes/common/infrastructure/ab-testing/optimizely/useOptimizely'
import styles from './Faq.module.css'

export function Faq() {
  const intl = useIntl()
  const { showMandatoryPaymentPage } = useOptimizelyFlagContext()

  let infoAndFAQsItems = useCMSPageField('Checkout.InfoAndFAQs')?.items

  if (!infoAndFAQsItems?.length) {
    return null
  }

  if (showMandatoryPaymentPage) {
    const faqPaymentTitles = [
      'Wanneer moet ik mijn vakantie (aan)betalen?', // SZ
      'Wanneer moet ik mijn vakantie betalen?', // BZ
    ]

    infoAndFAQsItems = infoAndFAQsItems.map(item =>
      faqPaymentTitles.includes(item.title)
        ? { ...item, text: intl.formatMessage({ id: 'checkout_steps_faq_ab_test_mandatory_payment_text' }) }
        : item,
    )
  }

  return (
    <div className={styles.faqContainer}>
      <div className={styles.faqTitleWrapper}>
        <Typography className={styles.faqTitle} variant="body-l-bold-tight">
          {intl.formatMessage({ id: 'checkout_steps_faq_title' })}
        </Typography>
      </div>
      <div className={styles.faqList}>
        {infoAndFAQsItems?.map(item => (
          <Sheet.Root key={item.title}>
            <Sheet.Trigger>
              <button
                type="button"
                className={styles.faqItem}
              >
                <Typography variant="body-l-regular-loose">{item.title}</Typography>
                <Icon glyph="ChevronRight" size={20} />
              </button>
            </Sheet.Trigger>
            <Sheet.Body side="right">
              <Sheet.Header
                titleLabel={item.title}
                closeLabel={intl.formatMessage({ id: 'close' })}
              />
              <Sheet.Content>
                <RichText innerHTML={item.text} />
              </Sheet.Content>
            </Sheet.Body>
          </Sheet.Root>
        ))}
      </div>
    </div>
  )
}
